import Parse from "parse";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  checkAlreadyAnswerClear,
  checkAlreadyAnswerError,
  checkAlreadyAnswerSuccess,
  checkAnswerError,
  checkAnswerLoading,
  checkAnswerSuccess,
  getHomeBannerError,
  getHomeBannerLoading,
  getHomeBannerSuccess,
  getHomeCourseError,
  getHomeCourseLoading,
  getHomeCourseSuccess,
  getQuestionOfTheDayError,
  getQuestionOfTheDayLoading,
  getQuestionOfTheDaySuccess,
} from "./actions";
import { APP_ID } from "../../utils/helpers";
import {
  CHECK_ALREADY_ANSWERED,
  CHECK_ANSWER,
  GET_HOME_BANNER,
  GET_HOME_COURSE,
  GET_QUESTION_OF_THE_DAY,
} from "./constants";
import { refactorQuestion } from "./utils";

function* getHomeBannerMethod() {
  try {
    yield put(getHomeBannerLoading());
    const res = new Parse.Query("elearning_Banners");
    res.equalTo("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });
    const response = yield call(() => res.find());
    if (response) {
      const images = response.map((item) => item.get("ImgUrl"));
      yield put(getHomeBannerSuccess(images));
    }
  } catch (error) {
    yield put(
      getHomeBannerError(
        error?.message || "Error occurred during get home banner."
      )
    );
  }
}

function* getHomeCourseMethod({ payload }) {
  try {
    yield put(getHomeCourseLoading());
    const courseQuery = new Parse.Query("elearning_Course");
    courseQuery.equalTo("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });
    courseQuery.notEqualTo("IsDeleted", true);
    courseQuery.ascending("createdAt");
    // courseQuery.limit(6);
    const result = yield call(() => courseQuery.find());
    if (result) {
      const parseResult = JSON.parse(JSON.stringify(result));
      let freeCourse = parseResult.filter((x) => x.CoursePaidType);
      const registeredCourse = new Parse.Query("elearning_Subscriptions");
      registeredCourse.equalTo("CustomerPtr", {
        __type: "Pointer",
        className: "elearning_Customer",
        objectId: payload,
      });
      registeredCourse.equalTo("TxnStatus", "Success");
      registeredCourse.greaterThan("EndDate", new Date());
      const subscribedData = yield call(() => registeredCourse.find());

      if (subscribedData) {
        const parseSubscribedData = JSON.parse(JSON.stringify(subscribedData));
        // let registeredArr = parseResult.filter(function (obj) {
        //   return parseSubscribedData.some(function (obj2) {
        //     return obj.objectId === obj2.CoursePtr.objectId;
        //   });
        // });
        yield put(
          getHomeCourseSuccess({
            courses: freeCourse,
            subscribedCourses: parseSubscribedData,
          })
        );
      } else {
        yield put(
          getHomeCourseSuccess({ courses: freeCourse, subscribedCourses: [] })
        );
      }
    }
  } catch (error) {
    yield put(
      getHomeCourseError(
        error?.message || "Error occurred during get course data."
      )
    );
  }
}

function* getQuestionOfDayMethod({ payload }) {
  try {
    yield put(getQuestionOfTheDayLoading());
    // to get current date with 00 time
    const dateDD = new Date();
    dateDD.setHours(0, 0, 0, 0);
    // To get Next Day date with 00 time
    const tomorrow = new Date(+new Date() + 86400000);
    tomorrow.setHours(0, 0, 0, 0);
    const qodQuery = new Parse.Query("test_QuestionOfDay");
    qodQuery.equalTo("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });
    qodQuery.include("QuestionPtr");
    qodQuery.greaterThanOrEqualTo("Date", dateDD);
    qodQuery.lessThan("Date", tomorrow);
    const result = yield call(() => qodQuery.find());
    if (result?.length) {
      const questionOfDay = JSON.parse(JSON.stringify(result));
      const db = refactorQuestion(questionOfDay);
      if (db.status) {
        yield put(getQuestionOfTheDaySuccess(db.data));
      } else {
        yield put(
          getQuestionOfTheDayError(
            db?.error || "Error occurred during get question of the day."
          )
        );
      }
    }
  } catch (error) {
    yield put(
      getQuestionOfTheDayError(
        error?.message || "Error occurred during get question of the day."
      )
    );
  }
}

function* checkAlreadyAnswerMethod({ payload }) {
  try {
    const qodQueryList = new Parse.Query("test_QuestionOfDayAnswer");
    qodQueryList.equalTo("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });
    qodQueryList.equalTo("CustomerPtr", {
      __type: "Pointer",
      className: "elearning_Customer",
      objectId: payload,
    });
    qodQueryList.include("QuestionOfDayPtr.QuestionPtr");
    qodQueryList.descending("createdAt");
    const result = yield call(() => qodQueryList.first());
    if (result) {
      const questionOfDay = JSON.parse(JSON.stringify(result));
      const entryDate = questionOfDay.createdAt;
      const currEntryDate = new Date(entryDate).toLocaleDateString();
      const checkCurrDate = new Date().toLocaleDateString();
      if (currEntryDate !== checkCurrDate) {
        yield put(checkAlreadyAnswerSuccess(true));
      } else {
        yield put(checkAlreadyAnswerSuccess(false));
      }
    } else {
      yield put(checkAlreadyAnswerSuccess(false));
    }
  } catch (error) {
    yield put(
      checkAlreadyAnswerError(
        error?.message || "Error occurred during check aleady QoD answered."
      )
    );
  }
}

function* checkAnswerMethod({ payload }) {
  try {
    const { answer, right, quesId, customer, qodPtrId } = payload;
    yield put(checkAnswerLoading());
    let submitArray = [];

    for (var i = 1; i < answer; i++) {
      submitArray.push(null);
    }
    submitArray.push(answer);

    const submitAnswer = [
      {
        CorrectAnswer: [right],
        ObtainedMarks: 0,
        SubmittedAnswer: submitArray,
        TestQuestionsPtr: {
          __type: "Pointer",
          className: "test_TestQuestions",
          objectId: quesId,
        },
      },
    ];
    const qodQueryList = new Parse.Object("test_QuestionOfDayAnswer");
    qodQueryList.set("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });
    qodQueryList.set("CustomerPtr", {
      __type: "Pointer",
      className: "elearning_Customer",
      objectId: customer,
    });
    qodQueryList.set("QuestionOfDayPtr", {
      __type: "Pointer",
      className: "test_QuestionOfDay",
      objectId: qodPtrId,
    });
    qodQueryList.set("IsCorrect", right === answer?.toString() ? true : false);
    qodQueryList.set("SubmittedAnswer", submitAnswer);
    const result = yield call(() => qodQueryList.save());
    if (result) {
      yield put(checkAnswerSuccess(result));
      yield put(checkAlreadyAnswerClear());
    }
  } catch (error) {
    yield put(
      checkAnswerError(error?.message || "Error occurred during submit answer.")
    );
  }
}

function* homeSagas() {
  yield takeEvery(GET_HOME_BANNER, getHomeBannerMethod);
  yield takeEvery(GET_HOME_COURSE, getHomeCourseMethod);
  yield takeEvery(GET_QUESTION_OF_THE_DAY, getQuestionOfDayMethod);
  yield takeEvery(CHECK_ALREADY_ANSWERED, checkAlreadyAnswerMethod);
  yield takeEvery(CHECK_ANSWER, checkAnswerMethod);
}

export default homeSagas;
